<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Pagination from "@/router/layouts/table-pagination.vue";
import Datatable from "@/router/layouts/table-datatable.vue";

import ModalFormValidator from "./components/modal-form-validator.vue";

export default {
  page: {
    title: "Master Verifikasi Validator",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    Pagination,
    Datatable,
    ModalFormValidator,
  },

  data() {
    let sortOrders = [];

    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Nama", name: "nama" },
      { width: "25%", label: "List Kompetensi", name: "list_kompetensi" }, // jika tidak ada sorting kasih name dengan karakter -
      { width: "auto", label: "User Upload", name: "user_upload" }, // jika tidak ada sorting kasih name dengan karakter -
      { width: "40%", label: "Aksi", name: "-" }, // jika tidak ada sorting kasih name dengan karakter -
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    const menu = "Master - Validator";
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      title: menu,
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      user_name: localStorage.session_name,
      pathPhoto: localStorage.session_path_photo,
      pathPhotoFull:
        process.env.VUE_APP_BACKEND_URL + localStorage.session_path_photo,
      loadingTable: false,
      tableData: [],
      columns: columns,
      sortKey: "nama_referensi",
      sortOrders: sortOrders,

      tableFilter: {
        page: 1,
        per_page: 10,
        nama_file: "",
        active_flag: 1,
        column: "idverif_file_referensi",
        dir: "asc",
      },

      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },

      modalConfiguration: {
        validator: false,
        tableLog: false,
      },

      // variable form referensi
      selectedDataFormValidator: null,
      formModeValidator: "add",

      expandedRows: {}

    };
  },

  mounted(){
    this.pagination.from = 1
    this.tableData = [
      {
        'id_nama': 2,
        'nama' : 'Bambang',
        'list_kompetensi': '123',
        'id_jabatan' : 3,
        'jabatan' : 'Jabatan 3',
        'id_validator_pengganti' : 2,
        'validator' : 'Nama Sample 2',
        'id_user_upload' : 2,
        'user_upload' : 'User Sample B',
        'alasan': 'Testing alasan 1'
      }
    ]
  },

  methods: {
    getDataTable(){

    },

    addValidator(){
      this.formModeValidator = 'add';
      this.selectedDataFormValidator = null;
      this.modalConfiguration.validator = true;
    },

    editValidator(data){
      this.formModeValidator = 'edit';
      this.selectedDataFormValidator = data;
      this.modalConfiguration.validator = true;
    },

    toggleExpand(index) {
      this.expandedRows[index] = !this.expandedRows[index];
    },
    isExpanded(index) {
      return !!this.expandedRows[index];
    },

    showModalSetupKompetensi(){
      alert('hallo')
      this.modalConfiguration.tableLog = true;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Filter -->
            <div class="row">
              <!-- Left: Select -->
              <div class="col-12 col-sm-2">
                <select
                  id="filterStatus"
                  class="form-control input-sm"
                  v-model="tableFilter.active_flag"
                  @change="getDataTable(true)"
                >
                  <option value="1">Aktif</option>
                  <option value="0">Tidak Aktif</option>
                </select>
              </div>

              <div class="col-12 col-sm-10 text-end">
                <b-button variant="primary" size="sm" @click="addValidator">
                  <i class="fa fa-plus"></i>
                  Tambah
                </b-button>
              </div>
            </div>

            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getTableData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i>
                      Loading
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length < 1">
                    <td colspan="99" class="text-center">Data Empty</td>
                  </tr>
                  <tr v-else v-for="(row, index) in tableData" :key="index">
                    <td class="text-center">{{ index + pagination.from }}</td>
                    <td class="text-center">
                      {{ row?.nama ?? "-" }}
                    </td>
                    <td>
                      <div v-if="row?.list_kompetensi">
                        <div>
                          <div class="blockBar" 
                            v-b-toggle="'collapse-' + index"
                            @click="toggleExpand(index)"
                          >
                            <i 
                              v-if="!isExpanded(index)"
                              class="fa fa-caret-right me-1 fa-fw">
                            </i>
                            <i
                              v-else 
                              class="fa fa-caret-down me-1 fa-fw">
                            </i>
                            <span class="blockTitle">
                              {{ row.list_kompetensi }}
                            </span>
                          </div>
                        </div>

                        <b-collapse :id="'collapse-' + index">
                          <div>
                            <span class="me-2">
                              <i class="fa fa-circle me-1"></i> Selesai
                            </span>

                            <span>
                              <i class="fa fa-user me-1"></i> Recycle
                            </span>
                          </div>
                          
                          <div>
                            <span>
                              <i class="fa fa-user me-1"></i> User
                            </span>
                          </div>

                          
                        </b-collapse>
                      </div>
                      <span v-else>-</span>
                    </td>
                    <td>
                      {{ row?.user_upload ?? "-" }}
                    </td>
                    <td v-if="isWrite == 1" class="text-center">
                      <div class="btn-group">
                        <b-button
                          v-if="tableFilter.active_flag == 1"
                          size="sm"
                        >
                          <i class="fa fa-plus me-1"></i>
                          Buat Surat Berita Acara
                        </b-button>

                        <b-button
                          v-if="tableFilter.active_flag == 1"
                          variant="primary"
                          size="sm"
                          @click="showModalSetupKompetensi"
                        >
                          <i class="fa fa-cog me-1"></i>
                          Setup Kompetensi
                        </b-button>

                        <b-button
                          v-if="tableFilter.active_flag == 1"
                          variant="warning"
                          size="sm"
                          @click="editValidator(row)"
                        >
                          <i class="fa fa-edit me-1"></i>
                          Edit
                        </b-button>

                        <b-button
                          v-if="tableFilter.active_flag == 1"
                          variant="danger"
                          size="sm"
                        >
                          <i class="fa fa-trash me-1"></i>
                          Disable
                        </b-button>

                        <b-button
                          v-if="tableFilter.active_flag == 0"
                          variant="success"
                          size="sm"
                        >
                          <i class="fa fa-recycle me-1"></i>
                          Enable
                        </b-button>

                        <button
                          v-if="tableFilter.active_flag == 0"
                          class="btn btn-danger btn-sm"
                          @click="destroy(row.idverif_soal_tindakan)"
                        >
                          <i class="fa fa-trash me-1"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
              <Pagination
                :pagination="pagination"
                @to-page="toPage"
              ></Pagination>
            </div>

            <div class="row">
              <div class="col-12">
                <ModalFormValidator 
                  :show="modalConfiguration.validator"
                  :data="selectedDataFormValidator"
                  :mode="formModeValidator"
                  @close="modalConfiguration.validator = false"
                  @finish="getDataTable()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>